module.exports = __webpack_public_path__ + "img/icono-xls.58854f40.svg";